import { BlockedImage } from '@approvalmax/ui';
import { Flex, Link, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { messages } from './ErrorCard.messages';

export const ErrorCard = memo(() => {
    return (
        <Flex alignItems='center' direction='column' spacing='24'>
            <BlockedImage />

            <Text font='headline' fontSize='small' as='h1' uppercase>
                {messages.title}
            </Text>

            <Flex direction='column' spacing='12'>
                <Text font='body' fontSize='medium'>
                    {messages.apologize}
                </Text>

                <Text font='body' fontSize='medium'>
                    {messages.reasons({
                        br: <br />,
                    })}
                </Text>

                <Text font='body' fontSize='medium'>
                    {messages.contactUs}
                </Text>

                <Link font='label' textAlign='center' href='mailto:support@approvalmax.com' external>
                    support@approvalmax.com
                </Link>
            </Flex>
        </Flex>
    );
});

ErrorCard.displayName = 'ErrorCard';
